import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateShowInstanceDocument } from './create-instance.generated';

export const useCreateShowInstance = (
  options: ApiOptions<typeof CreateShowInstanceDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(CreateShowInstanceDocument, {
    ...useNotifications(CreateShowInstanceDocument, {
      failure: t('api.common.error_generic'),
      success: (data) =>
        t('api.shows.create_instance_success', {
          deviceGroup: data.createShowInstance?.deviceGroup?.name,
          event: data.createShowInstance?.event?.name,
        }),
    }),
    ...options,
  });
};
